/* We're not filtering to see any kind of words here because the <InputMask> api does this for us already */

export const getRawValue = (value: string): string => {
  const regex = new RegExp(/_|\//gi);
  return value.replace(regex, '');
};

export const checkInputError = (value: string) => {
  return getRawValue(value).length === 8;
};
